import React, {useContext} from 'react'
import Box from '@mui/material/Box';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { formularioContext } from '../contextos/FormularioContext'

export const Ubicacion = ({id_provincia,handleChangeProvincia,textoCustom,disabled})=>{
    const {provincias} = useContext(formularioContext)

    return <Box sx={{display:'flex', flexDirection:'column'}}> 

        <Box sx={{marginTop:'2rem'}}>
            <InputLabel style={{textAlign:'left'}} id="lbl-sexo">{textoCustom || 'Provincia'}</InputLabel>
            <FormControl fullWidth>
                    <Select fullWidth
                        labelId="select-label-provincia"
                        id="sl-provincia"
                        disabled={disabled || false}
                        value={id_provincia}
                        label="Provincia"
                        onChange={handleChangeProvincia}
                    >
                        {provincias.map(item=>{
                            return <MenuItem value={item.id_provincia}>{item.nombre}</MenuItem>
                        })}

                    </Select>
            </FormControl>
        </Box>
     </Box>
}